import Profile from "../containers/Profile"

export default () => {
    return (
        <Profile/>
    )
}
